import React from 'react';
import styled from 'styled-components';
import { useStateValue } from '../../State/StateProvider';

function CheckoutProduct({ id, image, title, price }) {

    const [{ basket }, dispatch] = useStateValue();
    const removeFromBasket = () => {
        //remove the item from the basket
        dispatch({
            type: 'REMOVE_FROM_BASKET',
            id: id,
        })

    }

    return (
        <Container>
            <img className='checkoutProduct__image' src={image} alt={title} />

            <div className="checkoutProduct__info">
                <p className='checkoutProduct__title'>{title}</p>
                <p className='checkoutproduct__price'>
                    {/* <small>₹</small> */}
                    <strong>₹{price}</strong>
                </p>
                <button onClick={removeFromBasket}>Remove from Basket</button>
            </div>

        </Container>
    )
}

export default CheckoutProduct


const Container = styled.div`
    display: flex;
    /* background: red; */
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 0.5rem;
    border: 1px solid #dddddd;
    /* box-shadow: 1px -1px 25px 3px rgba(226, 223, 223, 0.9);
    -webkit-box-shadow: 1px -1px 25px 3px rgba(226, 223, 223, 0.9);
    -moz-box-shadow: 1px -1px 25px 3px rgba(226, 223, 223, 0.9); */
    .checkoutProduct__info {
        padding-left: 1.2rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        /* align-items: center; */

    }
    .checkoutproduct__price{
        color: #e21f36;
        font-size: 1.2rem;
    }

    .checkoutProduct__info > button{
        /* width: 5rem; */
        font-family: "Inter", sans-serif;
        font-weight: bold;
        font-size: 0.8rem;
        cursor: pointer;
        padding: 0.5rem 0.5rem;
        margin: 1rem 0rem 0rem 0rem;
        border: none;
        transition: all 0.5s ease;
        box-shadow: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.4) inset;
        /* background: #E21F36; */
        background: orangered;
        color: white;
        width: 12rem;
        &:hover{
            opacity: 0.9;
        }
    }

    .checkoutProduct__image {
        object-fit: contain;
        width: 15rem;
        height: 15rem;
        /* border: 2px solid brown; */
    }

    .checkoutProduct__title {
        font-size: 1.5rem;
        font-weight: 400;
        color: #000219;
    }

    @media screen and (max-width: 768px) {
    .checkoutProduct {
        justify-content: space-between;
    }
    .checkoutProduct__image {
        width: 100px;
    }
    }

`